import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  emp_firstName: "",
  emp_Designation: "",
  emp_IsSecuredDataAccessEnabled: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetState: () => initialState,
    addUserState: (state, action) => {
      const { emp_firstName, emp_Designation, emp_IsSecuredDataAccessEnabled } = action.payload;
      if (emp_firstName && emp_Designation) {
        state.emp_firstName = emp_firstName;
        state.emp_Designation = emp_Designation;
        state.emp_IsSecuredDataAccessEnabled = emp_IsSecuredDataAccessEnabled;
      }
    },
  },
});

export const { resetState, addUserState } = userSlice.actions;
export default userSlice.reducer;
